import React, { useEffect } from 'react'
import { useLocation, useHistory } from 'react-router-dom'

import { routes } from 'Routes'

import { Page } from 'components'
import Login from './components/Login'

import { COMPANY_TOKEN_LOGIN_WITH_ID } from 'service/env'

import useStyles from './styles'

import { Grid } from '@material-ui/core'

import AOS from 'aos'
import 'aos/dist/aos.css'

import useSnackbar from 'hooks/useSnackbar'

import * as service from 'service'

import useAuth from 'hooks/useAuth'

const LandingPage = () => {
  const classes = useStyles()
  const location = useLocation()
  const snackbar = useSnackbar()
  const auth = useAuth()
  const history = useHistory()

  const locationState = location.state
  const message = locationState
    ? locationState.error || locationState.success
    : ''

  useEffect(() => {
    AOS.init({
      duration: 1250,
      disable: function () {
        var maxWidth = 800
        return window.innerWidth < maxWidth
      },
    })
  }, [])

  useEffect(() => {
    if (locationState) {
      if (locationState.error) {
        snackbar.open({ message: message, variant: 'error' })
      } else {
        snackbar.open({ message: message, variant: 'success' })
      }
    }
    // eslint-disable-next-line
  }, [message, locationState])

  const loginWithButton = async () => {
    const response = await window.getTokenAuth()

    await service.marketPlace.auth.login({
      companyToken: COMPANY_TOKEN_LOGIN_WITH_ID,
      token: response?.token,
      companySubdomain: 'dponet',
    })
    auth.loadDataWithAnimation()
    history.push(routes.home)
  }

  const signUpButton = async () => {
    const response = await window.signUpOneID()
    snackbar.open({ message: response.message, variant: response.status })
  }

  return (
    <Page className={classes.root} title="Seja um Parceiro DPOnet">
      <input
        type="hidden"
        id="leavening_company_token"
        value={COMPANY_TOKEN_LOGIN_WITH_ID}
      />
      <Grid container className={classes.rootBody}>
        <Login signUpButton={signUpButton} loginWithButton={loginWithButton} />
      </Grid>
    </Page>
  )
}

export default LandingPage
